import QWS from "./components/timeline";

function App() {
  return (
    <div className="App">
      <QWS />
    </div>
  );
}

export default App;
